
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";

import { DbInuseResult, TCMScheduleSheetGoal,  TCMScheduleSheetGoalService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { createTCMScheduleSheet } from "./schedule-sheet.service";




export interface TCMScheduleSheetGoalOptions extends ControllerOptions<TCMScheduleSheetGoal> {

}

export const createTCMScheduleSheetGoal = (inObj: Partial<TCMScheduleSheetGoal>) => {

    let item: TCMScheduleSheetGoal = {
        id: "",
        name: inObj.name || "",
        points: inObj.points || 0,
        specificGoal: inObj.specificGoal ?? {
            id: "",
            validationKey: "",
            createdBy: "",
            name: "",
            goalType: "system",
            goalArea: "schedule"
        },
        parameters: undefined,
        createdBy: "",
        sheet: inObj.sheet ?? createTCMScheduleSheet({})
    }
    return item;
}

export class ClientTCMScheduleSheetGoalService extends BaseClientService implements DataController<TCMScheduleSheetGoal> {

    private _service: TCMScheduleSheetGoalService;


    constructor() {
        super();
        this._service = new TCMScheduleSheetGoalService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMScheduleSheetGoalOptions): Promise<ResultData<TCMScheduleSheetGoal>> {

        if (!this.params.scheduleId)
            throw new Error(`Schedule Id Parameter required.`)
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }

    public async pointsTotal(sheetId: string, exclude?: string): Promise<number> {
        let data = await this._service.pointsTotal( this.token, sheetId, exclude);
        return data;
    }
    public async getLookup(options: TCMScheduleSheetGoalOptions): Promise<ResultData<TCMScheduleSheetGoal>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMScheduleSheetGoalOptions): Promise<TCMScheduleSheetGoal | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMScheduleSheetGoalOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMScheduleSheetGoalOptions): Promise<TCMScheduleSheetGoal | TCMScheduleSheetGoal[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMScheduleSheetGoalOptions): Promise<TCMScheduleSheetGoal | TCMScheduleSheetGoal[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

      public async validateName(name: string, id?: string): Promise<ValidateResult> {
            return await this._service.validateName(name, this.token, id)
        }

    public async inUse(options: ControllerOptions<TCMScheduleSheetGoal>): Promise<DbInuseResult[]> {
        return await this._service.inUse(options.id || '', this.token);
    }





}
